import script from "./BatchView.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchView.vue?vue&type=script&setup=true&lang=js"

import "./BatchView.vue?vue&type=style&index=0&id=b21890e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b21890e8"]])

export default __exports__